import { ViewModel, View, ObservableArray, ObservableArrayChangeListenner, DelegatedObservableArrayChangeListenner } from "binder"
import { ProductLineManipulationView } from "./productLineManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { IProductLine } from "./IProductLine";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { distinct, stringIsNullOrEmpty } from "src/common/utilities";
import { ProductLineEditorViewModel, ProductLineInserter, ProductLineUpdater } from "./productLineEditor/productLineEditor-viewModel";

export class ProductLineManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف خط تولید';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.productLines = ObservableArray.create<ProductLine>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductLineManipulationView();
    }
    public getTypeId(): string {
        return "VM-1B963D7A-6706-4A56-BFBB-228F6A29051A"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productLines(v: ObservableArray<ProductLine>) { this._productLines = v; } public get productLines(): ObservableArray<ProductLine> { return this._productLines; } private _productLines: ObservableArray<ProductLine>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/ProductLineServices/ListAllProductLines', {
                FilteringInformation: filteringInformation
            });
            this.productLines.update(...result.ProductLines.map((x, i) => {
                let p = new ProductLine(this);
                p.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                p.id = x.Id;
                p.name = x.Name;
                p.code = x.Code;
                p.comment = x.Comment;
                p.opcId = x.OpcId;
                p.opcName = x.OpcName;
                p.opcCode = x.OpcCode;
                return p;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new ProductLineEditorViewModel(this, new ProductLineInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(productLine: IProductLine) {
        let popup = new ProductLineEditorViewModel(this, new ProductLineUpdater());
        await productLine.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async duplicate(productLine: ProductLine) {
        let isDuplicate = await this.messageBoxWarningYesNo(`آیا خط تولید ${productLine.name} دوباره ایجاد شود؟`, `ایجاد دوباره`);
        if (isDuplicate == 'yes') {
            let result = await ServerConnection.callServer("/Complex/ProductLineServices/DuplicateProductLine", {
                productLineId: productLine.id,
            });
            if (result.IsSuccessful == true) {
                await this.messageBoxConfirmSuccess("با موفقیت دوباره ایجاد شد.", "عملیات موفق");
                this.dataLoader.refresh();
            }
            else {
                await this.messageBoxConfirmWarning("امکان ایجاد دوباره وجود ندارد", "خطا در عملیات");
            }
        }
    }

    async remove(productLine: ProductLine): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                let result = await ServerConnection.callServer("/Complex/ProductLineServices/DeleteProductLine", {
                    productLineId: productLine.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class ProductLine extends ViewModel implements IProductLine {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ProductLineManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: ProductLineManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set opcId(v: string) { this._opcId = v; } public get opcId(): string { return this._opcId; } private _opcId: string;
    public set opcName(v: string) { this._opcName = v; } public get opcName(): string { return this._opcName; } private _opcName: string;
    public set opcCode(v: string) { this._opcCode = v; } public get opcCode(): string { return this._opcCode; } private _opcCode: string;

    setOpcId(id: string) {
        this.opcId = id;
    }
    getOpcId(): string {
        return this.opcId;
    }

    async cloneTo(productLine: IProductLine) {
        productLine.id = this.id;
        productLine.name = this.name;
        productLine.code = this.code;
        productLine.comment = this.comment;
        productLine.setOpcId(this.opcId);
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async duplicate() {
        this._typedParent.duplicate(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }

    async showStructure() {
        let workStationStructure = new WorkStationStructureViewModel(this);
        workStationStructure.loadById(this.opcId, this.id);
        this.requestShowingPopup(workStationStructure);
    }
}

export class WorkStationStructureViewModel extends ViewModel implements IPopup {
    public getTypeId(): string { return 'workstation-structure'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
        this.workStations = ObservableArray.create<SingleWorkStation>();
        this.opList = ObservableArray.create<OPViewModel>();
    }

    private changeListenner: ObservableArrayChangeListenner;
    public set workStations(v: ObservableArray<SingleWorkStation>) {
        this._workStations = v;

        if (this._workStations != null) {
            this._workStations.removeChangeListenner(this.changeListenner);
        }
        this._workStations = v;
        if (this._workStations != null) {
            let listenner = new DelegatedObservableArrayChangeListenner(this, arr => this.listChanged());
            this._workStations.addChangeListenner(listenner);
        }

    } public get workStations(): ObservableArray<SingleWorkStation> { return this._workStations; } private _workStations: ObservableArray<SingleWorkStation>;
    public set opList(v: ObservableArray<OPViewModel>) { this._opList = v; } public get opList(): ObservableArray<OPViewModel> { return this._opList; } private _opList: ObservableArray<OPViewModel>;
    private _productLineId: string;

    private listChanged() {
        this.workStations.forEach((x, i) => x.index = i + 1);
    }

    closePopup(result: any) {

    }

    back() {
        this.closePopup(null);
    }

    async loadById(opcId: string, productLineId: string) {
        this._productLineId = productLineId;
        try {
            let opResult = await ServerConnection.callServer('/Complex/OpcServices/GetOpcStructure', {
                OpcId: opcId
            });
            this.opList.update(...opResult.Activities.map((x, i) => {
                let s = new OPViewModel(this);
                s.index = i + 1;
                s.id = x.Id;
                s.name = x.Name;
                s.code = x.Code;
                return s;
            }));
            let workStationResult = await ServerConnection.callServer('/Complex/ProductLineServices/GetAllProductLineWorkStations', {
                ProductLineId: productLineId
            });
            this.workStations.update(...workStationResult.WorkStations.map((x, i) => {
                let s = new SingleWorkStation(this);
                s.index = i + 1;
                s.id = x.WorkStationId;
                s.name = x.Name;
                s.code = x.Code;
                s.comment = x.Comment;
                s.availableOPs = this.opList;
                s.selectedOP = s.availableOPs.filter(y => y.id == x.ActivityId).at(0);
                return s;
            }));
        } catch (ex) {
            console.log(ex);
        }
    }

    async addWorkStation() {
        let singleWorkStation = new SingleWorkStation(this);
        singleWorkStation.availableOPs = this.opList;
        singleWorkStation.index = this.workStations.length;
        this.workStations.push(singleWorkStation);
    }

    async removeWorkStation(singleWorkStation: SingleWorkStation) {
        this.workStations.remove(singleWorkStation);
    }

    async save(): Promise<void> {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت چیدمان ایستگاه های کاری');
            return;
        } else {
            try {
                let result = await ServerConnection.callServer("/Complex/ProductLineServices/UpdateProductLineWorkStations", {
                    ProductLineId: this._productLineId,
                    WorkStationUpdateData: this.workStations.map(q => {
                        return {
                            Name: q.name,
                            Comment: q.comment,
                            Code: q.code,
                            ActivityId: q.selectedOP.id,
                            WorkStationId: q.id
                        }
                    })
                });
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                } else {
                    await this.messageBoxConfirmSuccess('چیدمان ایستگاه های کاری با موفقیت ثبت شد.', 'ثبت موفق');
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت چیدمان ایستگاه های کاری', 'خطا در عملیات');
                console.log(ex);
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (this.workStations.filter(x => stringIsNullOrEmpty(x.name)).length > 0) {
            result.push('نام یک یا چند ایستگاه مشخص نشده است.');
        }
        if (this.workStations.filter(x => x.selectedOP == null).length > 0) {
            result.push('نام یک یا چند OP مشخص نشده است.');
        }
        let distinctNames = distinct(this.workStations.map(x => x.name));
        if (distinctNames.length != this.workStations.length) {
            result.push('نام تکراری در ایستگاه های کاری وجود دارد.');
        }
        return result;
    }
}

export class SingleWorkStation extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: WorkStationStructureViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: WorkStationStructureViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set availableOPs(v: ObservableArray<OPViewModel>) { this._availableOPs = v; } public get availableOPs(): ObservableArray<OPViewModel> { return this._availableOPs; } private _availableOPs: ObservableArray<OPViewModel>;
    public set selectedOP(v: OPViewModel) {
        this._selectedOP = v;
        this.selectedOpCode = v == null ? '' : v.code;
    } public get selectedOP(): OPViewModel { return this._selectedOP; } private _selectedOP: OPViewModel;
    public set selectedOpCode(v: string) { this._selectedOpCode = v; } public get selectedOpCode(): string { return this._selectedOpCode; } private _selectedOpCode: string;

    async remove() {
        this._typedParent.removeWorkStation(this);
    }
}

export class OPViewModel extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
}